<template>
  <div class="container">
    <!--成员数据-->
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">成员数据</div>
        <div class="title-desc">
          成员签约工作室后，上传作品产生的收益及互动数据
        </div>
      </div>
      <div class="content-inner-wrap">
        <div class="data-filter">
          <span class="mgr25">数据维度 </span>
          <span class="btnGroup">
            <el-radio-group v-model="membersDataType">
              <el-radio label="1" border size="medium" v-if="permission">
                收益</el-radio
              >
              <el-radio label="2" border size="medium">互动</el-radio>
            </el-radio-group>
            <!-- <el-radio-group v-model="membersDataType" v-else>
              <el-radio label="1" border size="medium">互动</el-radio>
            </el-radio-group> -->
          </span>
        </div>
        <div class="data-filter">
          <span class="mgr25">选择日期</span>
          <el-date-picker
            v-model="membersDate"
            type="daterange"
            align="left"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :picker-options="pickerOptions"
            @change="membersDateChange"
          >
          </el-date-picker>
          <el-button
            @click="handleMDateBtnClicked"
            class="search_btn"
            type="info"
            >查找</el-button
          >
        </div>
        <div class="select-box">
          <div class="label">成员类型</div>
          <el-select v-model="state" placeholder="请选择" @change="changeType">
            <el-option
              v-for="item in memberOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="data-table" v-loading="membersDataLoading">
          <el-table
            :key="222"
            :data="membersData"
            stripe
            v-if="membersDataType == 1"
          >
            <el-table-column
              align="center"
              prop="name"
              label="名称"
              class-name="tb-name"
              fixed
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="uin"
              label="迷你号"
              class-name="tb-uin"
              fixed
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="member_type"
              label="类型"
              class-name="tb-type"
            >
              <template slot-scope="scope">
                {{
                  scope.row.vip
                    | MembersTypeFilter(
                      scope.row.position,
                      scope.row.state,
                      state,
                    )
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="minibean"
              label="累计迷你豆"
              class-name="tb-minibean"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="minipoint"
              label="累计迷你点"
              class-name="tb-minipoint"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="contribution"
              label="累计贡献点"
              class-name="tb-contribution"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="ad_count"
              label="广告播放次数"
              class-name="tb-adCount"
            >
            </el-table-column>
            <!-- <el-table-column
              align="center"
              prop="ad_income"
              label="广告收入"
              class-name="tb-ad_income"
            >
              <el-table-column
                align="center"
                prop="ad_income"
                label="广告收入"
                class-name="tb-ad_income"
              >
              </el-table-column>
            </el-table-column> -->
            <el-table-column label="广告收入" align="center">
              <el-table-column
                label="触发器收入"
                prop="ad_trigger"
                align="center"
              >
                <template slot="header">
                  <el-tooltip placement="top">
                    <span
                      >触发器收入
                      <img
                        class="icon-help"
                        src="@/assets/images/icon_help.png"
                      />
                    </span>

                    <p slot="content" style="font-size: 16px; color: #fff">
                      在地图作品中，用户通过触发器观看的广告记为内购商店广告，该收入是广告收入的一部分。
                    </p>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                label="内购商店收入"
                prop="ad_shop"
                align="center"
              >
                <template slot="header">
                  <el-tooltip placement="top">
                    <span
                      >内购商店收入
                      <img
                        class="icon-help"
                        src="@/assets/images/icon_help.png"
                      />
                    </span>

                    <p slot="content" style="font-size: 16px; color: #fff">
                      在地图作品中，用户通过观看开发者商店内商品的广告记为内购商店广告，该收入是广告收入的一部分。
                    </p>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                label="通行证收入"
                prop="ad_passcheck"
                align="center"
              >
                <template slot="header">
                  <el-tooltip placement="top">
                    <span
                      >通行证收入
                      <img
                        class="icon-help"
                        src="@/assets/images/icon_help.png"
                      />
                    </span>

                    <p slot="content" style="font-size: 16px; color: #fff">
                      在地图作品中，用户通过观看畅玩通行证的广告记为通行证广告，该收入是广告收入的一部分。
                    </p>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                label="其他广告收入"
                prop="ad_other"
                align="center"
              >
              </el-table-column>
              <el-table-column label="合计" prop="ad_sum" align="center">
              </el-table-column>
            </el-table-column>
            <el-table-column
              align="center"
              label="激励金收入"
              class-name="tb-other"
            >
              <el-table-column
                align="center"
                prop="xq4_time"
                label="星启激励A"
                class-name="tb-star"
              >
                <template slot="header">
                  <el-tooltip placement="top">
                    <span>
                      星启激励A
                      <img
                        class="icon-help"
                        src="@/assets/images/icon_help.png"
                      />
                    </span>
                    <p slot="content" style="font-size: 16px; color: #fff">
                      2024年7-2025年1月为星启6.0时长激励，2024年1-6月为星启5.0内购时长激励，2023年为星启4.0时长激励
                    </p>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.other_xingqi4_time || 0 }}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="xq4_shop"
                label="星启激励B"
                class-name="tb-star"
              >
                <template slot="header">
                  <el-tooltip placement="top">
                    <span>
                      星启激励B
                      <img
                        class="icon-help"
                        src="@/assets/images/icon_help.png"
                      />
                    </span>
                    <p slot="content" style="font-size: 16px; color: #fff">
                      2025年2月及以后为星启7.0内购激励，2024年7-2025年1月为星启6.0内购激励，2024年1-6月为星启5.0广告激励，2023年为星启4.0内购激励
                    </p>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.other_xingqi4_shop || 0 }}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="other_xingqi2"
                label="星启计划2.0"
                class-name="tb-star"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="other_xingqi3"
                label="星启计划3.0"
                class-name="tb-star"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="other_match"
                label="赛事奖金"
                class-name="tb-star"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="other_dingzhi"
                label="定制奖金"
                class-name="tb-star"
              >
              </el-table-column>
              <!-- <el-table-column
                align="center"
                prop="event"
                label="（赛事/奖金/定制）备注"
                class-name="tb-star"
              >
              </el-table-column> -->
              <el-table-column
                align="center"
                prop="other_newstar"
                label="新星计划奖金"
                class-name="tb-star"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="star_sum"
                label="合计"
                class-name="tb-star"
              >
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-table :key="35464" :data="membersViewData" stripe v-else>
            <el-table-column
              align="center"
              label="成员名称"
              prop="name"
              class="name"
              fixed
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="迷你号"
              prop="uin"
              class="tb-uin"
            >
            </el-table-column>

            <el-table-column
              align="center"
              label="类型"
              prop="member_type"
              class="tb-member_type"
            >
              <template slot-scope="scope">
                {{ scope.row.vip | VMemberTypeFilter(scope.row.member_type) }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="作品数"
              prop="map_count"
              class="tb-map_count"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="最近上传"
              prop="add_map_last_time"
              class="add_map_last_time"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="昨日下载"
              prop="yesterday_download_count"
              class="tb-yesterday_download_count"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="累计下载量"
              prop="download_count"
              class="tb-download_count"
            >
            </el-table-column>
            <el-table-column align="center">
              <template slot="header"><span>操作</span></template>
              <template slot-scope="scope">
                <span
                  class="all-look"
                  v-if="scope.row.vip == 1"
                  @click="
                    $router.push({
                      name: 'detailPage',
                      params: {
                        member_id: scope.row.uin,
                        memberType: scope.row.member_type,
                      },
                    })
                  "
                  >查看详情</span
                >
                <span class="all-look" @click="toastMessage" v-else>
                  查看详情</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="data-filter-page" v-if="membersDataType == 1">
          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :total="membersDataPageCount"
            @current-change="mDPaginationChange"
          >
          </el-pagination>
        </div>
        <div class="data-filter-page" v-else>
          <el-pagination
            background
            layout="prev, pager, next,jumper"
            :total="membersViewDataPageCount"
            @current-change="mVPaginationChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStudioMembersIncome,
  getStudioMembersOverview,
  getPermiss,
} from '@/api/studio';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
export default {
  data() {
    return {
      membersDataLoading: false,
      membersPagination: {
        page_size: 10,
        page: 1,
      },
      membersViewPagination: {
        page_size: 10,
        page: 1,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      memberOptions: [
        {
          label: '当前成员',
          value: 2,
        },
        {
          label: '退出/解约成员',
          value: 6,
        },
      ],
      state: 2,
      permission: false,
      membersDate: '',
      position: 0,
      lastMembersDate: [],
      membersDataType: '1',
      membersData: [],
      membersViewData: [],
      membersDataPageCount: 0,
      membersViewDataPageCount: 0,
    };
  },
  created() {
    //const currTime = Date.now()
    // if (!this.permission) {
    //   this.membersDataType = '2';
    // }
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.membersDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  mounted() {
    //成员数据-收益数据
    this.getMembersData();
    //成员数据-互动数据
    this.getVMembersData();
    this.getPerssion();
  },
  filters: {
    MembersTypeFilter(vip, position, state, state1) {
      //判断查询的是否正式成员
      if (state1 == 2) {
        // if (state == 2) {
        if (vip) {
          if (position == 1) return '室长';
          else if (position == 2) return '签约成员';
          else return '管理员';
        } else return '普通成员';
        // }
      } else {
        //代表已退出/已解约
        if (state == 2) {
          //已解约
          if (vip) {
            if (position == 1) return '室长';
            else if (position == 2) return '签约成员(已解约)';
            else return '管理员(已解约)';
          } else return '普通成员(已解约)';
        } else {
          //已退出
          if (vip) {
            if (position == 1) return '室长';
            else if (position == 2) return '签约成员(已退出)';
            else return '管理员(已退出)';
          } else return '普通成员(已退出)';
        }
      }
      // if (state == 2) {
      //   if (vip) {
      //     if (position == 1) return '室长';
      //     else if (position == 2) return '签约成员';
      //     else return '管理员';
      //   } else return '普通成员';
      // } else {
      //   if (vip) {
      //     if (position == 1) return '室长';
      //     else if (position == 2) return '签约成员(已退出)';
      //     else return '管理员(已退出)';
      //   } else return '普通成员(已退出)';
      // }
    },
    VMemberTypeFilter(vip, type) {
      if (vip) {
        return type == 1 ? '室长' : '签约成员';
      } else {
        return '普通成员';
      }
    },
  },
  methods: {
    handleMDateBtnClicked() {
      if (this.membersDataType == 2) {
        this.getVMembersData();
      } else {
        this.getMembersData();
      }

      // this.getMembersData()
      //this.getVMembersData()
    },
    //判断是否有收入查看权限
    async getPerssion() {
      let res = await getPermiss({ json: 1 });
      this.position = res.data.position;
      if (res.data.v1m_income == 1 || this.position == 1) {
        this.permission = true;
      } else {
        this.permission = false;
      }
      if (!this.permission) {
        this.membersDataType = '2';
      }
    },
    exportFn() {
      this.fetchExport();
    },
    //切换成员类型
    changeType() {
      this.getMembersData();
    },
    //导出数据
    async fetchExport() {},
    toastMessage() {
      this.$message.error('仅能查看签约成员数据哦');
    },
    membersDateChange() {
      console.log('membersDateChange', this.membersDate);
    },
    mDPaginationChange(currPage) {
      this.membersPagination.page = currPage;
      this.getMembersData();
    },
    mVPaginationChange(currPage) {
      this.membersViewPagination.page = currPage;
      this.getVMembersData();
    },
    async getMembersData() {
      this.membersDataLoading = true;
      this.lastMembersDate = this.membersDate;
      const res = await getStudioMembersIncome(
        Object.assign(this.membersPagination, {
          start_time: parseInt(this.membersDate[0] / 1000, 10),
          end_time: parseInt((this.membersDate[1] + ONE_DAY_TIME) / 1000, 10),
          state: this.state,
        }),
      );
      this.membersDataLoading = false;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.membersData = list.map(item => {
            item.contribution = Number(item.contribution).toFixed(3);
            item.ad_sum =
              (
                item.ad_passcheck +
                item.ad_trigger +
                item.ad_shop +
                item.ad_other
              ).toFixed(2) || 0;
            item.star_sum =
              (
                item.other_xingqi2 +
                item.other_xingqi3 +
                item.other_match +
                item.other_dingzhi +
                item.other_newstar +
                item.other_xingqi4_shop +
                item.other_xingqi4_time
              ).toFixed(2) || 0;
            return item;
          });
        } else this.membersData = [];
        this.membersDataPageCount = parseInt(res.data.total_count, 10);
      }
    },
    //成员数据-互动表
    async getVMembersData() {
      this.membersDataLoading = true;
      this.lastMembersDate = this.membersDate;

      const res = await getStudioMembersOverview(
        Object.assign(this.membersViewPagination, {
          start_time: parseInt(this.membersDate[0] / 1000, 10),
          end_time: parseInt((this.membersDate[1] + ONE_DAY_TIME) / 1000, 10),
          json: 1,
        }),
      );
      this.membersDataLoading = false;
      this.membersViewData = res.data.list;
      this.membersViewDataPageCount = parseInt(res.data.total_count, 10);
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.container {
  .data-table {
    margin-top: 28px;
    border: 1px solid #d9d9d9;
    overflow: hidden;
    border-radius: 3px;
    ::v-deep .el-table tr:last-child td {
      border-bottom: none;
    }
    ::v-deep .el-table::before {
      background: transparent;
    }
    ::v-deep .el-table th {
      background: #fafafa;
      line-height: 29px;
    }
    ::v-deep .el-table td {
      line-height: 29px;
      padding: 7px 0 6px;
    }
  }
  ::v-deep .el-button--text {
    color: #2b6ddf;
  }
  ::v-deep .el-date-editor.el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ::v-deep .el-range-editor.el-input__inner {
    padding: 3px 0;
  }
  ::v-deep .el-date-editor .el-range__icon {
    display: none;
  }
  ::v-deep .el-date-editor .el-range-separator {
    width: 30px;
    color: #bfbfbf;
  }
  .search_btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    color: #595959;
    border-right: 1px solid #d9d9d9;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    background-color: #f4f4f5;
  }
  .select-box {
    display: flex;
    align-items: center;
    .label {
      margin-right: 25px;
    }
    .el-select {
      width: 135px;
    }
  }
  .download-wrap {
    float: right;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    margin-top: 18px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #2b6ddf;
    img {
      margin-right: 8px;
    }
  }
  .all-look {
    color: #2b6ddf;
    text-decoration: underline;
    cursor: pointer;
    display: flex;
    justify-content: center;
  }
  img.icon-help {
    height: 10px;
    width: 10px;
  }
}
</style>
